const paymentTotals = [
  { label: 'Processed', value: '$124K', detail: 'Last 30 days' },
  { label: 'Pending', value: '$18K', detail: 'Awaiting approvals' },
  { label: 'Disbursed', value: '$94K', detail: 'Week to date' },
];

const paymentActivity = [
  { title: 'Payout CW-2049', amount: '$420', status: 'Settled' },
  { title: 'Expense reimbursement · Delta', amount: '$80', status: 'Pending' },
  { title: 'Bonus payout · CW-2052', amount: '$150', status: 'Processing' },
];

function PaymentsPage() {
  return (
    <div className="space-y-6">
      <header>
        <p className="text-xs uppercase tracking-[0.6em] text-emerald-500">Payments</p>
        <h1 className="text-3xl font-semibold text-slate-900">Money movement</h1>
        <p className="text-slate-600">
          Keep an eye on budgets, pending payouts, and small reimbursements across the Carewinners payer stack.
        </p>
      </header>
      <section className="grid gap-4 md:grid-cols-3">
        {paymentTotals.map((item) => (
          <article
            key={item.label}
            className="rounded-3xl border border-emerald-100 bg-emerald-50/80 px-5 py-6 shadow-lg shadow-emerald-200/40"
          >
            <p className="text-xs uppercase tracking-[0.4em] text-emerald-600">{item.label}</p>
            <p className="mt-3 text-3xl font-semibold text-slate-900">{item.value}</p>
            <p className="text-sm text-slate-500">{item.detail}</p>
          </article>
        ))}
      </section>
      <section className="rounded-3xl border border-emerald-100 bg-white p-6 shadow-sm shadow-slate-200">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-slate-900">Recent activity</h2>
          <button type="button" className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-600">
            View history
          </button>
        </div>
        <ul className="mt-4 space-y-4 text-sm text-slate-600">
          {paymentActivity.map((activity) => (
            <li key={activity.title} className="flex items-center justify-between rounded-2xl border border-emerald-100 px-4 py-3 bg-emerald-50/60">
              <div>
                <p className="font-semibold text-slate-900">{activity.title}</p>
                <p className="text-xs text-slate-500">{activity.status}</p>
              </div>
              <p className="text-lg font-semibold text-slate-900">{activity.amount}</p>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default PaymentsPage;
